import { HttpClient } from "@angular/common/http"
import { Injectable } from "@angular/core"
import { AppConfig, UserInfo } from "@corporate-tailwind/model"
import { Observable, of } from "rxjs"
import { BaseUrlService } from "../base-url/base-url.service"

@Injectable({ providedIn: 'root' })
export class UserApi {

    constructor(
        private _httpClient: HttpClient,
        private _baseUrlService: BaseUrlService
    ) {  }

    getAnonymousUser(): Observable<UserInfo> {
        const user = new UserInfo({
            name: "Anonymous user",
            login: "ANONYMOUS",
            isAuthorized: true
        })

        return of(user)
    }

    getManazUser(): Observable<UserInfo> {
        return this.getUser()
    }

    getUser(): Observable<UserInfo> {
        return this._httpClient
            .get<UserInfo>(this._baseUrlService.getApiUrl('user/info'), { withCredentials: true })
    }

    getAppConfig(): Observable<AppConfig[]> {
        return this._httpClient
            .get<AppConfig[]>(`/cdn/assets/logo/apps/app-list.txt`)
    }
}
